import React, { useEffect, useRef, useState } from 'react';

import { t } from '../../../config/i18n';
import { ClockIcon, Defaults, Row, TextEx } from '../../common';

const ProgressiveTimer = ({
  time,
  top,
  left,
  right,
  fontSize = '1.4rem',
  hint,
  noIcon = false,
}: {
  time: number;
  top?;
  left?;
  right?;
  fontSize?: number | string;
  hint?: string;
  noIcon?: boolean;
}) => {
  const [TimerId] = useState('Timer__' + Math.floor(Math.random() * 1000000));
  const [date, setDate] = useState(time);

  useEffect(() => {
    const expiresIn = Math.round(Date.now() / 1000 + date);
    sessionStorage.setItem(TimerId, expiresIn.toString());
    return () => sessionStorage.removeItem(TimerId);
  }, []);

  useEffect(() => {
    const Listener = () => {
      const date = sessionStorage.getItem(TimerId);
      if (date) {
        const expiresIn = Math.round(+date - Date.now() / 1000);
        setDate(expiresIn > 0 ? expiresIn : 0);
      }
    };
    window.addEventListener('focus', Listener);
    return () => window.removeEventListener('focus', Listener);
  }, []);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setDate((prevTime) => {
        !prevTime && sessionStorage.removeItem(TimerId);
        return prevTime ? --prevTime : 0;
      });
    }, 1000);
    return () => clearInterval(intervalId);
  }, []);

  const tick = date % 2 === 0;
  const minutes = date ? Math.floor(date / 60) : 0;
  const seconds = date ? date - minutes * 60 : 0;

  return (
    <Row top={top} left={left} right={right} title={t(hint)}>
      {!noIcon ? <ClockIcon size={'2.714rem'} fill={Defaults.grayColor} /> : undefined}
      <TextEx
        weight={'500'}
        size={fontSize}
        left={'0.6vh'}
        width={'2.143rem'}
        textAlign={'right'}>
        {String(minutes).padStart(2, '0')}
      </TextEx>
      <TextEx
        weight={'500'}
        size={fontSize}
        color={tick ? 'transparent' : undefined}
        width={'.8125rem'}
        textAlign={'center'}>
        :
      </TextEx>
      <TextEx weight={'500'} size={fontSize} width={'2.143rem'} textAlign={'left'}>
        {String(seconds).padStart(2, '0')}
      </TextEx>
    </Row>
  );
};

export default React.memo(ProgressiveTimer);
